import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import { debounce } from 'lodash';
import React, { useState, useEffect, useCallback } from 'react';
import { Col, Form, Row, Container, ButtonGroup, Button } from "react-bootstrap";
import { useHistory } from 'react-router-dom';
import { RadioButton, StateBootstrapButton as StateButton } from '../forms/elements';
import { mobilepayDuck } from "../../ducks/mobilepay"; // import { ApplePay, applePayEnabled } from '../cart/ApplePay';

import { ApplePayMP } from '../cart/ApplePayMP';
import { EProtectSection } from "./MobilePayEProtectCC";
import applePayImage from '../../images/apple-pay-logo-icon.png';
import gPayImage from '../../images/gpay.png';
import payPalImage from '../../images/paypalLogo.jpg';
import { GooglePay, googlePayEnabled } from "./GooglePay";
var mobilepayOperations = mobilepayDuck.operations;

var SectionBanner = function SectionBanner(_ref) {
  var _ref$value = _ref.value,
      value = _ref$value === void 0 ? "" : _ref$value,
      index = _ref.index,
      activeCategoryIndex = _ref.activeCategoryIndex,
      _ref$defaultActive = _ref.defaultActive,
      defaultActive = _ref$defaultActive === void 0 ? false : _ref$defaultActive,
      children = _ref.children,
      _ref$showNumber = _ref.showNumber,
      showNumber = _ref$showNumber === void 0 ? true : _ref$showNumber;
  return /*#__PURE__*/React.createElement("h2", {
    className: "mobilepay-section-banner ".concat(activeCategoryIndex === index || defaultActive ? "is-active" : "")
  }, (showNumber ? index + 1 + ". " : "") + value, children);
};

var BottomLine = function BottomLine(_ref2) {
  var children = _ref2.children;
  return /*#__PURE__*/React.createElement("div", {
    className: "cb-checkout__bottom-line"
  }, children);
};

export var MobiliePayPayments = function MobiliePayPayments(props) {
  var _savedCards$;

  var total = props.total,
      check = props.check,
      gratuity = props.gratuity,
      code1 = props.code1,
      setPayOrderPayload = props.setPayOrderPayload,
      orderId = props.orderId,
      values = props.values,
      isLoading = props.isLoading,
      activeCategoryIndex = props.activeCategoryIndex,
      showMobilePayWPError = props.showMobilePayWPError,
      payForOrder = props.payForOrder,
      setCanUseApplePay = props.setCanUseApplePay,
      hideApplePaymentOption = props.hideApplePaymentOption,
      index = props.index,
      forceDisabled = props.forceDisabled,
      loading = props.loading,
      _props$editHide = props.editHide,
      editHide = _props$editHide === void 0 ? false : _props$editHide,
      changeHandler = props.changeHandler,
      _props$savedCards = props.savedCards,
      savedCards = _props$savedCards === void 0 ? [] : _props$savedCards,
      _props$setFieldValue = props.setFieldValue,
      setFieldValue = _props$setFieldValue === void 0 ? function () {
    return "";
  } : _props$setFieldValue,
      isRetail = props.isRetail,
      isFood = props.isFood,
      isCatering = props.isCatering,
      _props$handleContinue = props.handleContinue,
      handleContinue = _props$handleContinue === void 0 ? function () {
    return "";
  } : _props$handleContinue,
      _props$functionName = props.functionName,
      functionName = _props$functionName === void 0 ? function () {
    return "";
  } : _props$functionName,
      _props$setActiveCateg = props.setActiveCategoryIndex,
      setActiveCategoryIndex = _props$setActiveCateg === void 0 ? function () {
    return "";
  } : _props$setActiveCateg,
      AUTHSTATE = props.AUTHSTATE,
      isPaypal = props.isPaypal,
      children = props.children,
      externalPayment = props.externalPayment,
      editFunction = props.editFunction,
      _props$hideGooglePay = props.hideGooglePay,
      hideGooglePay = _props$hideGooglePay === void 0 ? false : _props$hideGooglePay,
      _props$hidePaypal = props.hidePaypal,
      hidePaypal = _props$hidePaypal === void 0 ? false : _props$hidePaypal,
      _props$googleLoaded = props.googleLoaded,
      googleLoaded = _props$googleLoaded === void 0 ? false : _props$googleLoaded,
      _props$setGoogleLoade = props.setGoogleLoaded,
      setGoogleLoaded = _props$setGoogleLoade === void 0 ? function () {} : _props$setGoogleLoade,
      _props$giftCardInfo = props.giftCardInfo,
      giftCardInfo = _props$giftCardInfo === void 0 ? {
    num: 0
  } : _props$giftCardInfo,
      Remaining = props.Remaining,
      Cost = props.Cost,
      _props$isOfflineStore = props.isOfflineStore,
      isOfflineStore = _props$isOfflineStore === void 0 ? false : _props$isOfflineStore,
      canUseApplePay = props.canUseApplePay,
      canUseGooglePay = props.canUseGooglePay,
      hideGiftCard = props.hideGiftCard,
      paymentType = props.paymentType,
      setPaymentType2 = props.setPaymentType2,
      setGiftCard = props.setGiftCard,
      setGiftCardPin = props.setGiftCardPin,
      giftCard = props.giftCard,
      giftCardPin = props.giftCardPin;

  var _useState = useState(!savedCards.length),
      _useState2 = _slicedToArray(_useState, 2),
      newCard = _useState2[0],
      setCardType = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      saveCard = _useState4[0],
      setSaveCard = _useState4[1];

  var _useState5 = useState(((_savedCards$ = savedCards[0]) === null || _savedCards$ === void 0 ? void 0 : _savedCards$.SavedCardId) || ""),
      _useState6 = _slicedToArray(_useState5, 2),
      selectedSavedCard = _useState6[0],
      setSelected = _useState6[1];

  var disableEprotect = false; //TODO 
  // console.log("[Mobile Pay] Payments Checkout  ",props)
  // const [externalPayment, setExternalPayment] = useState(false);
  // const [paymentType, setPaymentType2] = useState('creditcard')

  var setPaymentType = function setPaymentType(paymentType) {
    if (paymentType !== "apple") {
      // setHideApplePay(false)
      setCanUseApplePay(false);
    } else {
      // setHideApplePay(true)
      setCanUseApplePay(true);
    }

    setPaymentType2(paymentType);
  };

  var handleSavedCard = function handleSavedCard(el) {
    setSelected(el.SavedCardId);
    setCardType(false);
    setFieldValue('usestoredcard', true); // setFieldValue("wptokenizedpan", el.WPTokenizedPAN)

    setFieldValue("savedcardid", el.SavedCardId);
    setFieldValue("cardNumber", el.MaskedCardNumber);
    setFieldValue("expirymonth", el.ExpiryMonth);
    setFieldValue("expiryyear", el.ExpiryYear);
    setFieldValue("cardtype", el.MerchantType);
    setFieldValue("cvv", "000");
  };

  useEffect(function () {
    if (savedCards.length) {
      if (!externalPayment) {
        var _savedCards$2;

        handleSavedCard(savedCards[0]);
        setSelected((_savedCards$2 = savedCards[0]) === null || _savedCards$2 === void 0 ? void 0 : _savedCards$2.SavedCardId);
        setFieldValue('usestoredcard', true);
      }
    } else {
      setFieldValue('usestoredcard', false);
    }
  }, [savedCards, externalPayment]);

  var handlePaymentChange = function handlePaymentChange(type) {
    setPaymentType(type);

    if (type !== 'creditcard') {
      var _document, _element$getBoundingC;

      // editFunction(1);
      var id = 'cb-external-payment';
      var yOffset = -80;
      var element = (_document = document) === null || _document === void 0 ? void 0 : _document.getElementById(id);
      var y = (element === null || element === void 0 ? void 0 : (_element$getBoundingC = element.getBoundingClientRect()) === null || _element$getBoundingC === void 0 ? void 0 : _element$getBoundingC.top) + window.pageYOffset + yOffset;
      if (y) window.scrollTo({
        top: y,
        behavior: 'smooth'
      });
    } //   setExternalPayment(!externalPayment);


    var paymentType = 'creditcard';
    var entryMode = 'E-COMM';

    switch (type) {
      case 'paypal':
        paymentType = 'paypal';
        entryMode = null;

      case 'apple':
        paymentType = 'apple';
        entryMode = 'E-COMM';
        setFieldValue('isPaypal', false);
        setFieldValue('paypalTransaction', null);
        setFieldValue('paypalId', null);

      case 'google':
        paymentType = 'google';
        entryMode = 'E-COMM';
        setFieldValue('isPaypal', false);
        setFieldValue('paypalTransaction', null);
        setFieldValue('paypalId', null);

      case 'creditcard':
        paymentType = 'creditcard';
        entryMode = null;
        setFieldValue('isPaypal', false);
        setFieldValue('paypalTransaction', null);
        setFieldValue('paypalId', null);
    }

    setFieldValue('entrymode', entryMode);
    setFieldValue('paymentMethod', paymentType);
  }; // Need to move this to avoid rerender
  // const canUseGooglePay = googlePayEnabled(props); //googlePayEnabled(props);


  var checkGooglePay = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var resp;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return googlePayEnabled(props);

            case 2:
              resp = _context.sent;
              console.log(resp); // setCanUseGooglePay(resp.result)

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function checkGooglePay() {
      return _ref3.apply(this, arguments);
    };
  }();

  useEffect(function () {
    if (googleLoaded) {
      checkGooglePay();
    }
  }, [googleLoaded]);
  return (
    /*#__PURE__*/
    // <Form id="fCheckout" name="fCheckout">
    React.createElement("div", {
      className: "mt-3"
    }, /*#__PURE__*/React.createElement(BottomLine, null, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(RadioButton, {
      name: "paymentType",
      value: "creditcard",
      checked: paymentType === 'creditcard',
      onChange: function onChange() {
        return handlePaymentChange('creditcard');
      },
      className: "cb-type-body-sm pt-12",
      labelClass: paymentType === 'creditcard' ? "is-active" : ""
    }, /*#__PURE__*/React.createElement("span", null, "Credit Card")), canUseApplePay && !hideApplePaymentOption && !disableEprotect && /*#__PURE__*/React.createElement(RadioButton, {
      name: "paymentType",
      value: "external",
      checked: paymentType === 'apple',
      onChange: function onChange() {
        return handlePaymentChange('apple');
      },
      className: "cb-type-body-sm pt-12",
      labelClass: paymentType === 'apple' ? "is-active" : ""
    }, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("img", {
      className: "cb-checkout__payment-logo",
      src: applePayImage,
      border: "0",
      width: 40,
      alt: "Apple Pay Logo"
    }), "\xA0Pay with Apple Pay")), canUseGooglePay && !hideGooglePay && !disableEprotect && /*#__PURE__*/React.createElement(RadioButton, {
      name: "paymentType",
      value: "external",
      checked: paymentType === 'google',
      onChange: function onChange() {
        return handlePaymentChange('google');
      },
      className: "cb-type-body-sm pt-12",
      labelClass: paymentType === 'google' ? "is-active" : ""
    }, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("img", {
      className: "cb-checkout__payment-logo",
      src: gPayImage,
      width: 40,
      border: "0",
      alt: "Google Pay Logo"
    }), "\xA0Pay with Google Pay")), !hideGiftCard && /*#__PURE__*/React.createElement(RadioButton, {
      name: "paymentType",
      value: "external",
      checked: paymentType === 'giftcard',
      onChange: function onChange() {
        return handlePaymentChange('giftcard');
      },
      className: "cb-type-body-sm pt-12",
      labelClass: paymentType === 'giftcard' ? "is-active" : ""
    }, /*#__PURE__*/React.createElement("span", null, "\xA0Pay with Gift Card")), isRetail && !hidePaypal && !isFood && !isCatering && /*#__PURE__*/React.createElement(RadioButton, {
      name: "paymentType",
      value: "external",
      checked: paymentType === 'paypal',
      onChange: function onChange() {
        return handlePaymentChange('paypal');
      },
      className: "cb-type-body-sm pt-12",
      labelClass: paymentType === 'paypal' ? "is-active" : ""
    }, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("img", {
      className: "cb-checkout__payment-logo",
      src: payPalImage,
      border: "0",
      alt: "PayPal Logo"
    }), "\xA0Pay with PayPal"))), /*#__PURE__*/React.createElement("section", null, /*#__PURE__*/React.createElement("div", null, Boolean(paymentType === 'creditcard') && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(EProtectSection, {
      index: 1,
      payForOrder: payForOrder,
      isLoading: isLoading,
      orderId: orderId,
      code1: code1,
      id: orderId,
      activeCategoryIndex: activeCategoryIndex,
      showMobilePayWPError: showMobilePayWPError,
      functionName: function functionName(a, b) {// setActiveCategoryIndex(a)
      },
      editFunction: function editFunction() {// setActiveCategoryIndex(sections.indexOf("Payment Info"));
      },
      tipAmount: gratuity,
      setPayOrderPayload: setPayOrderPayload,
      check: check
    })), Boolean(paymentType === 'google') && /*#__PURE__*/React.createElement("div", {
      className: "cb-l-margin-xxsmall--bottom"
    }, /*#__PURE__*/React.createElement(GooglePay, {
      check: check,
      gratuity: gratuity,
      setPayOrderPayload: setPayOrderPayload,
      payForOrder: payForOrder,
      cost: {
        Total: total
      },
      total: total,
      setGoogleLoaded: setGoogleLoaded
    })), /*#__PURE__*/React.createElement("div", {
      className: "cb-l-margin-xxsmall--bottom"
    }, /*#__PURE__*/React.createElement(ApplePayMP, {
      applePayEnabled: true,
      check: check,
      total: total,
      tipAmount: gratuity,
      gratuity: gratuity,
      payForOrder: payForOrder,
      canUseApplePay: canUseApplePay,
      setCanUseApplePay: setCanUseApplePay,
      hideApplePaymentOption: hideApplePaymentOption,
      selectedPaymentType: paymentType === 'apple',
      setPayOrderPayload: setPayOrderPayload
    })), Boolean(paymentType === 'giftcard') && /*#__PURE__*/React.createElement("div", {
      className: "cb-l-margin-xxsmall--bottom"
    }, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
      md: 12,
      lg: 6
    }, /*#__PURE__*/React.createElement("label", null, "Gift Card Number"), /*#__PURE__*/React.createElement("input", {
      value: giftCard,
      maxLength: 20,
      type: 'number',
      name: "giftCardNumber",
      label: "Gift Card Number",
      className: " cb-form__input form-control cb-form__input--full",
      onChange: function onChange(e) {
        setGiftCard(e.target.value);
      }
    })), /*#__PURE__*/React.createElement(Col, {
      md: 12,
      lg: 6
    }, /*#__PURE__*/React.createElement("label", null, "Pin Number"), /*#__PURE__*/React.createElement("input", {
      value: giftCardPin,
      maxLength: 4,
      type: 'number',
      name: "giftCardPin",
      label: "Pin Number",
      className: "cb-form__input cb-form__input--full form-control",
      onChange: function onChange(e) {
        setGiftCardPin(e.target.value);
      }
    })))))))) // </Form>

  );
};